import React, { useEffect, useRef } from 'react';
import './Basket.scss';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { ReactComponent as CloseIcon } from '../../assets/icons/new/close.svg'; // import { ReactComponent as ShareIcon } from '../../assets/icons/new/share.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/new/download.svg';
import { ReactComponent as ArrowDownBlackIcon } from '../../assets/icons/arrow-down-blcak.svg';
import { ReactComponent as ClockIcon } from '../../assets/icons/new/clock.svg';
import ProductRow from '../ProductRow';
import { bindActionCreators, Dispatch } from 'redux';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { RootState } from '../../reducers';
import * as _actionsBasket from '../../actions/basket';
import * as _actionsJourney from '../../actions/journey1';
import * as _actionsJourney2 from '../../actions/journey2';
import * as _actionsJourney3 from '../../actions/journey3';
import * as _actionsCheckout from '../../actions/checkout';
import * as actionsSujet from '../../actions/sujet';
import { withRouter } from '../../utils/withRouter';
import { parseToApiDate } from '../../utils/react';
import { Transition } from 'react-transition-group';
import ModalBackdrop from '../ModalBackdrop';
import Sidebar from '../Sidebar';
import { Button, EButtonType } from '@repo/apg-ui';
import { getPathname } from '../../utils/paths';
import { TypeContainer } from '../../actions/typeContainer';
import config from '../../constants/config';
import { prepareCreateBasketPayload } from '../../utils/payloads';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { useMedia } from 'react-use';
import { SchemaProduct } from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

interface Props {
  products: any;
  intl: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  total: number;
  loading: any;
  actionsBasket: typeof _actionsBasket;
  actionsJourney2: typeof _actionsJourney2;
  possibleBookingDates: any;
  productsJ2ByUrn: Record<string, SchemaProduct>;
  dispatch: Dispatch;
  containers: TypeContainer;
}

const Basket = ({
  products,
  total,
  userDataEC,
  userDataEC: { isAgencyJourney, agencyData, basketInfo, industry, startDate, isBasketOpen, duration, basketProducts },
  loading,
  actionsJourney2,
  possibleBookingDates,
  productsJ2ByUrn,
  actionsBasket,
  containers,
  dispatch,
}: Props) => {
  const ref = useRef(null);
  const url = config.apiUrl;
  const intl = useIntl();
  const productLists = products ? Object.keys(products).map((key) => products[key]) : [];
  const hasProducts = productLists && productLists.length > 0;
  const validCount = basketProducts?.stats?.totalcount ?? productLists.length;
  const isMobile = useMedia('(max-width: 768px)');

  const navigate = useNavigate();

  const handleClickOutside = (event: any) => {
    const digiflexModal = document.getElementsByClassName('digiflexModal')[0];
    const analogModal = document.getElementsByClassName('analogModal')[0];
    const productImageModal = document.getElementsByClassName('productImageModal')[0];
    let isBasketTrigger = false;

    if (event.target.className) {
      if (event.target.className.hasOwnProperty('includes')) {
        isBasketTrigger = event.target.className.includes('basket-trigger');
      }
    }
    if (ref.current && !ref.current.contains(event.target) && !isBasketTrigger) {
      if (digiflexModal && digiflexModal.contains(event.target)) {
        return;
      }

      if (analogModal && analogModal.contains(event.target)) {
        return;
      }

      if (productImageModal && productImageModal.contains(event.target)) {
        return;
      }

      actionsBasket.closeBasket();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  // ToDo: move functions below to J2 root
  const getProductPrice = (producturn: string, startDate: string) => {
    const payload = {
      producturn: producturn,
      startdate: startDate ? parseToApiDate(startDate) : '',
    };
    actionsJourney2.getPriceForProduct(payload);
  };

  const getAvailabilityForDigitalProduct = (producturn: string, startDate: string, duration: number) => {
    const payload = {
      producturn: producturn,
      startdate: parseToApiDate(startDate),
      duration: duration,
    };
    actionsJourney2.getAvailabilityForDigitalProduct(payload);
  };

  const changeProductDate = (basketEntry: number, startDate: string, duration: number) => {
    return actionsJourney2
      .changeProductDate({
        basketentry: basketEntry,
        basketreference: basketInfo.basketreference,
        startdate: parseToApiDate(startDate),
        duration: duration,
      })
      .then(() => {
        if (basketInfo && basketInfo.basket) {
          // @ts-expect-error properties of "state" don't match number vs union type:
          actionsBasket.getBasketContent(basketInfo).catch((err: any) => console.error(err));
        }
      })
      .catch((err: any) => console.error(err));
  };

  const updateDateAndDuration = (startDate: string, duration: number, producturn: string) => {
    const payload = {
      startdate: parseToApiDate(startDate),
      duration: duration,
      producturn: producturn,
    };
    actionsJourney2.updateDateAndDuration(payload);
  };

  const clearBasket = () => {
    actionsBasket
      .deleteBasket({
        basketreference: basketInfo.basketreference,
        basket: basketInfo.basket,
      })
      .then(() => {
        const basketPayload = prepareCreateBasketPayload('', industry, startDate);
        actionsBasket
          .createBasket(basketPayload)
          .then(() => {
            actionsBasket.closeBasket();
          })
          .catch((err: any) => console.error(err));
      })
      .catch((err: any) => console.error(err));
  };

  const getBasketName = () => {
    let basketName = '';
    if (isAgencyJourney) {
      basketName = agencyData?.campaignName;
    } else {
      basketName = basketInfo?.name;
    }

    return basketName || <FormattedMessage id='ec.checkout.warenkorb' defaultMessage='Warenkorb' />;
  };

  const isShowReserveButton = () => {
    if (!isAgencyJourney) {
      return false;
    } else {
      return !!(basketInfo?.possiblecategories || []).includes(3);
    }
  };

  const updateBasketCategory = (category: number, fallback: () => void) => {
    const payload = {
      basket: basketInfo?.basket,
      basketreference: basketInfo.basketreference,
      category: category,
    };

    actionsBasket.postBasketData(payload).then(() => {
      fallback();
    });
  };

  const proceedWithBasket = (category: number) => {
    const fallback = () => {
      navigate(getPathname(containers)(5));
      actionsBasket.closeBasket();
    };

    if (isAgencyJourney) {
      updateBasketCategory(category, fallback);
    } else {
      fallback();
    }
  };

  return (
    <Transition in={isBasketOpen} timeout={50}>
      {(state) => (
        <ModalBackdrop duration={250} state={state}>
          <Sidebar duration={250} state={state}>
            {isBasketOpen && (
              <div className={'basket-modal d-flex flex-column'} ref={ref}>
                <div className={'basket-modal__header d-flex flex-column w-100 '}>
                  <div className='w-100 d-flex flex-row justify-content-between'>
                    <div className={'d-flex flex-column'}>
                      <div className='d-flex flex-column'>
                        {isAgencyJourney && (
                          <div className={'font-14 mb-2 font-bold'}>{agencyData?.customer?.display}</div>
                        )}
                        <b className={'font-24'}>
                          {getBasketName()} {validCount > 0 && <span>({validCount})</span>}
                        </b>
                      </div>
                      {isMobile && <b className={'font-24 pe-4'}>CHF {total}</b>}
                    </div>
                    <div className={'d-flex flex-row align-items-center'}>
                      {!isMobile && <b className={'font-24 pe-4'}>CHF {total}</b>}
                      <CloseIcon
                        onClick={() => actionsBasket.closeBasket()}
                        className={'basket-modal basket-modal--close cursor-pointer'}
                      />
                    </div>
                  </div>
                  {isMobile && (
                    <div className='d-flex flex-row w-100 mt-24'>
                      {/*ToDo: temporary disable share button */}
                      {/*<Button*/}
                      {/*    className="mt-0"*/}
                      {/*    buttonType={EButtonType.BasicLink}*/}
                      {/*    isDisabled={!hasProducts}*/}
                      {/*>*/}
                      {/*    <ShareIcon className="me-3" />*/}
                      {/*    <FormattedMessage id="ec.basket.share" defaultMessage="Share" />*/}
                      {/*</Button>*/}
                      <Dropdown className='download-toggle ms-48'>
                        <Dropdown.Toggle
                          className='button mt-0 basicLink svg-fill fw-bold'
                          variant=''
                          disabled={!hasProducts}
                        >
                          <DownloadIcon className='me-3' />
                          <FormattedMessage id='ec.basket.download' defaultMessage='Download' />
                          <ArrowDownBlackIcon className='arrow ms-2' />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            href={`${url}basketcontent?basket=${basketInfo?.basket}&basketreference=${basketInfo?.basketreference}&format=pdf&language=${intl.locale}`}
                            target={'_blank'}
                            rel='noopener noreferrer'
                          >
                            <FormattedMessage id='ec.basket.pdf' defaultMessage='PDF' />
                          </Dropdown.Item>
                          <Dropdown.Item
                            href={`${url}basketcontent?basket=${basketInfo?.basket}&basketreference=${basketInfo?.basketreference}&format=xls&language=${intl.locale}`}
                            target={'_blank'}
                            rel='noopener noreferrer'
                          >
                            <FormattedMessage id='ec.basket.excel' defaultMessage='Excel' />
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  )}
                </div>
                <div className={'basket-modal__body'}>
                  {productLists?.map((product, idx) => (
                    <ProductRow
                      key={`productRow${product.producturn}-${idx}-${product.basketkey}`}
                      duration={duration || 7}
                      startDate={startDate || basketProducts.productsByUrnDate[product.basketkey]?.startdate}
                      getProductPrice={getProductPrice}
                      basketEntries={basketProducts.productsByUrnDate}
                      getAvailabilityForDigitalProduct={getAvailabilityForDigitalProduct}
                      changeProductDate={changeProductDate}
                      updateDateAndDuration={updateDateAndDuration}
                      possibleBookingDates={possibleBookingDates}
                      product={product}
                      loading={loading}
                      productNew={product}
                      journey2={true}
                      productsJ2ByUrn={productsJ2ByUrn}
                      userDataEC={userDataEC}
                      isShowRemoveAction={true}
                      isDigiflex={product.producttype === 'digital'}
                      isShortTimeslot={true}
                      isBasketRow={true}
                    />
                  ))}
                </div>
                <div className={'basket-modal__footer'}>
                  <div className='clear-all-button'>
                    <Button
                      className='mt-0 white-space-nowrap'
                      buttonType={EButtonType.BasicLink}
                      onClick={clearBasket}
                      isDisabled={!hasProducts}
                    >
                      <FormattedMessage id='ec.basket.clearAll' defaultMessage='Alles löschen' />
                    </Button>
                  </div>
                  <div className='d-flex flex-row align-items-center justify-content-center basket-actions'>
                    {!isMobile && (
                      <React.Fragment>
                        {/*<Button*/}
                        {/*    className="mt-0"*/}
                        {/*    buttonType={EButtonType.BasicLink}*/}
                        {/*    isDisabled={!hasProducts}*/}
                        {/*>*/}
                        {/*    <ShareIcon className="me-3" />*/}
                        {/*    <FormattedMessage id="ec.basket.share" defaultMessage="Share" />*/}
                        {/*</Button>*/}
                        <Dropdown className='download-toggle ms-3'>
                          <Dropdown.Toggle
                            className='button invertedPill medium mt-0 fw-bold'
                            variant=''
                            disabled={!hasProducts}
                          >
                            <DownloadIcon className='me-3' />
                            <FormattedMessage id='ec.basket.download' defaultMessage='Download' />
                            <ArrowDownBlackIcon className='arrow ms-2' />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              href={`${url}basketcontent?basket=${userDataEC.basketInfo?.basket}&basketreference=${userDataEC.basketInfo?.basketreference}&format=pdf&language=${intl.locale}`}
                              target={'_blank'}
                              rel='noopener noreferrer'
                            >
                              <FormattedMessage id='ec.basket.pdf' defaultMessage='PDF' />
                            </Dropdown.Item>
                            <Dropdown.Item
                              href={`${url}basketcontent?basket=${userDataEC.basketInfo?.basket}&basketreference=${userDataEC.basketInfo?.basketreference}&format=xls&language=${intl.locale}`}
                              target={'_blank'}
                              rel='noopener noreferrer'
                            >
                              <FormattedMessage id='ec.basket.excel' defaultMessage='Excel' />
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </React.Fragment>
                    )}
                    {isShowReserveButton() && (
                      <Button
                        className='mt-0 ms-3 reserve-button'
                        buttonType={EButtonType.InvertedPillMedium}
                        isDisabled={!hasProducts}
                        onClick={() => {
                          proceedWithBasket(3);
                        }}
                      >
                        <ClockIcon className={'clock-icon'} />
                        <FormattedMessage id='ec.basket.reserve' defaultMessage='Reserve' />
                      </Button>
                    )}
                    <Button
                      className='mt-0 ms-3 checkout-button'
                      buttonType={isAgencyJourney ? EButtonType.PillMedium : EButtonType.InvertedPillMedium}
                      isDisabled={!hasProducts}
                      onClick={() => {
                        proceedWithBasket(1);
                      }}
                    >
                      <FormattedMessage id='ec.basket.checkout' defaultMessage='Bestellung abschliessen' />
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </Sidebar>
        </ModalBackdrop>
      )}
    </Transition>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
    router: state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsJourney3: bindActionCreators(_actionsJourney3 as any, dispatch),
    actionsCheckout: bindActionCreators(_actionsCheckout as any, dispatch),
    actionsSujet: bindActionCreators(actionsSujet as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Basket)));
